<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="over"
    fixedInViewport="true"
    #sidenav>
    <nav class="navigation">
      <buyiq-navigation (clickNavigationItem)="sidenav.close()"></buyiq-navigation>
    </nav>
  </mat-sidenav>

  <header class="app-header">
    <buyiq-toolbar class="toolbar"
      (openNavigationMenu)="sidenav.open()">
    </buyiq-toolbar>
  </header>

  @if (!loading) {
    <main
      class="main-content"
      [class.login]="isLoginPage"
      cdkVirtualScrollingElement>
      <router-outlet></router-outlet>
    </main>
  } @else {
    <div class="loading-container">
      <mat-spinner color="accent"></mat-spinner>
      <p class="loading-message">Loading...</p>
    </div>
  }
</mat-sidenav-container>

